import { offlineStore } from "./offline_store"
import { apiGet, apiPost } from "../api_helper"
import { networkStatus } from "./network_status"

class SyncManager {
  constructor() {
    this.syncing = false
    this.listeners = []
    // Auto-sync when coming back online
    networkStatus.onChange((online) => {
      if (online) this.sync()
    })
  }

  onChange(callback) {
    this.listeners.push(callback)
  }

  notify() {
    this.listeners.forEach(cb => cb())
  }

  async sync() {
    if (this.syncing || !networkStatus.online) return
    this.syncing = true

    try {
      // 1. Push pending operations
      await this.pushPending()
      // 2. Pull fresh data from server
      await this.pullData()
      this.notify()
    } catch (e) {
      console.error("Sync error:", e)
    } finally {
      this.syncing = false
    }
  }

  async pushPending() {
    const operations = await offlineStore.getPendingOperations()
    if (!operations.length) return

    const result = await apiPost("/api/sync", { operations })

    // Remove successfully processed operations
    const processedIds = result.results
      .filter(r => r.status !== "error")
      .map(r => r.client_id)

    if (processedIds.length) {
      await offlineStore.removePendingOperations(processedIds)
    }

    // Update server_time for next sync
    if (result.server_time) {
      await offlineStore.setLastSyncTime(result.server_time)
    }
  }

  async pullData() {
    const since = await offlineStore.getLastSyncTime()
    const params = since ? `?since=${since}` : ""
    const data = await apiGet(`/api/sync${params}`)

    // Cache all received data
    if (data.transactions?.length) await offlineStore.cacheData("cached_transactions", data.transactions)
    if (data.categories?.length) await offlineStore.cacheData("cached_categories", data.categories)
    if (data.accounts?.length) await offlineStore.cacheData("cached_accounts", data.accounts)

    if (data.server_time) {
      await offlineStore.setLastSyncTime(data.server_time)
    }
  }

  async getPendingCount() {
    return offlineStore.getPendingCount()
  }
}

export const syncManager = new SyncManager()
